/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function a(a,n,c){return a.canvas||(a.canvas=document.createElement("canvas")),a.canvas.width=n,a.canvas.height=c,a.canvas}export{a as getTextHelperCanvas};
